
import { Component, Mixins } from 'vue-property-decorator';
import CommonDropMenu from '@/components/common/CommonDropMenu.vue';
import CommonTableHead from '@/components/common/CommonTableHead.vue';
import CommonRankName from '@/components/common/CommonRankName.vue';
import CommonLoading from '@/components/common/CommonLoading.vue';
import CommonRankNumber from '@/components/common/CommonRankNumber.vue';
import CommonRankFollow from '@/components/common/CommonRankFollow.vue';
import { industryRankHead, reportCoverDropMenu, STAT } from '@/config/config';
import { getRankIndustryList } from '@/apis/index';
import { RankMixin } from '@/utils/mixin';
import { pushBy2804 } from '@/utils/tools';

@Component({
  components: {
    CommonDropMenu,
    CommonTableHead,
    CommonRankName,
    CommonRankNumber,
    CommonRankFollow,
    CommonLoading,
  },
})
export default class IndustryRank extends Mixins(RankMixin) {
  toIndustry(info: any) {
    const stat = this.$route.name === 'rank' ? STAT.rank : STAT.homeRecommend;
    window.hxmClickStat(`${stat}.hangye`);
    if (!info.industryId) {
      return;
    }
    // 跳转路由 行业主页
    pushBy2804('/mainPage', {
      swCode: info.industryId,
      name: info.industryName,
    });
  }
  created() {
    this.dropMenu = reportCoverDropMenu;
    this.tableHead = industryRankHead('涨幅');
    this.api = getRankIndustryList;
    this.selectDate = window.getParam('industryselect') || '5';
    this.defaultDate = decodeURIComponent(window.getParam('industrydate')) || '近5日';
    this.refName = 'industryrank';
    this.followId = 'industryId';
    this.followType = '4';
  }
}
